import { useLocation } from 'react-router'
import { useMemo } from 'react'

export function useIsPageBuilder() {
  const { pathname } = useLocation()
  return useMemo(() => pathname.includes('page-builder'), [pathname])
}
